module.exports = __webpack_public_path__ + "static/modinfinity-97b0bf291f52bc47450234b4f5766544.svg";